<script setup>

import OverlayComponent from "@/components/OverlayComponent.vue";
import { ref } from "vue";

const startYear = ref(2020),
 currentYear = ref(new Date().getFullYear())

</script>

<template>
  <!--  @php-->
  <!--  $fromTo = null;-->
  <!--  $startYear = 2022;-->
  <!--  $currentYear = \Carbon\Carbon::now()->year;-->

  <!--  if ($startYear <= $currentYear) {-->
  <!--  $fromTo = "{$startYear} - {$currentYear}";-->
  <!--  } else {-->
  <!--  $fromTo = $startYear;-->
  <!--  }-->
  <!--  @endphp-->
  <footer
    class="sticky-footer shrink-0 ay-footer-bg py-4 relative"
    style="background-image: url('/images/default-header-bg-2.svg');
          background-position: bottom;
          background-size: cover;
          background-attachment: scroll;
  "
  >
    <div class="w-full relative z-20">
      <div class="container px-4">
        <div class="flex flex-wrap justify-between items-center mb-4">
          <div class="w-full md:w-4/12 mb-3 font-medium text-sm">
            <nav>
              <ul class="">
                <li>
                  <a
                    href="/"
                    class="hover:text-blue-600 text-white p-0"
                  >Home</a>
                </li>
                <li>
                  <a
                    href="/education"
                    class="hover:text-blue-600 text-white p-0"
                  >Education</a>
                </li>
                <li>
                  <a
                    href="/accommodation"
                    class="hover:text-blue-600 text-white p-0"
                  >Accommodation</a>
                </li>
                <li>
                  <a
                    href="/health"
                    class="hover:text-blue-600 text-white p-0"
                  >Health</a>
                </li>
                <li>
                  <a
                    href="/life-style"
                    class="hover:text-blue-600 text-white p-0"
                  >Life Style</a>
                </li>
                <li>
                  <a
                    href="/about"
                    class="hover:text-blue-600 text-white p-0"
                  >About</a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="w-full md:w-4/12 mb-3 d-flex justify-content-around align-items-center">
            <a
              href="{{ url('https://facebook.com/') }}"
              target="_blank"
              class="facebook-link text-light"
            >
              <span class="fab fa-facebook-square fa-3x fa-fw" />
            </a>

            <a
              href="{{ url('https://twitter.com/') }}"
              target="_blank"
              class="twitter-link text-light"
            >
              <span class="fab fa-twitter-square fa-3x fa-fw" />
            </a>

            <a
              href="{{ url('https://github.com/') }}"
              target="_blank"
              class="github-link text-light"
            >
              <span class="fab fa-whatsapp-square fa-3x fa-fw" />
            </a>
          </div>
          <div class="w-full md:w-4/12 mb-3 font-medium text-sm">
            <nav>
              <ul class="text-center">
                <li>
                  <a
                    href="/privacy"
                    class="nav-link text-white p-0"
                  >Privacy</a>
                </li>
                <li>
                  <a
                    href="/terms"
                    class="nav-link text-white p-0"
                  >Terms & Conditions</a>
                </li>
                <li>
                  <a
                    href="/about"
                    class="nav-link text-white p-0"
                  >Contact</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="text-center font-medium text-sm text-white pt-4 border-t border-amber-200">
        &copy;
        <span v-if="startYear < currentYear">{{ startYear }} - {{ currentYear }}</span>
        <span v-else>{{ startYear }}</span>
        Ghana Top | All Right Reserved | Made with
        <span class="text-red-600 h4">&hearts;</span>
        by
        <a
          href="https://github.com/stonec0der"
          class="text-white font-bold"
        >
          Cedric Megnie
        </a>
      </div>
    </div>
    <OverlayComponent :white-overlay="false" />
  </footer>
</template>

<style scoped>

</style>
